export const BASE_DOMAIN = 'https://cabinet.seiflombard.kz'
// export const BASE_DOMAIN = 'http://seiflombard.kz:8001'



// WEBPACK FOOTER //
// ./src/_config.js